/*
	Show/Hide Paswords
*/
let passwordToggle = document.querySelector('.jsTogglePwd');
let passwordField = document.querySelector('.jsToggleablePwd');

if (passwordField && passwordToggle) {
	passwordToggle.addEventListener('click', () => {
		if ( passwordField.getAttribute('type') == 'password' ) {
			passwordToggle.innerText = 'Hide';
			passwordField.setAttribute('type', 'text');
		} else {
			passwordToggle.innerText = 'Show';
			passwordField.setAttribute('type', 'password');
		}
	});
};